
import React from 'react';
import { saveAs } from 'file-saver';
import { pdf } from '@react-pdf/renderer';
import { DataSheetPDF } from './dataSheetPDF';



function DownloadSheet({data, fileName}) {


  const handleDownloadPDF = async () => {
    try {
      // 1. Generate the PDF instance from your custom component template
      const doc = <DataSheetPDF data={data} fileName={fileName} />;
      const asPdf = pdf([]); 
      asPdf.updateContainer(doc);
      
      // 2. Output the document layout as a raw file Blob
      const blob = await asPdf.toBlob();
      
      // 3. Force browser download using file-saver
      saveAs(blob, `${fileName}.pdf`);
    } catch (error) {
      console.error('Failed to generate and download PDF:', error);
    }
  };

  return (
    <div>
   
      <button className="nav-link funds-btn dark-p-history" onClick={handleDownloadPDF}   >
        PDF 
      </button>
    </div>
  );
}

export default DownloadSheet;